import * as actionTypes from './actionTypes'
import * as API from '../api/Speclization'

export const addSpecializationAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.SPECIALZATION_ADD_TO_REQUEST, payload: data})
        return API.addSpecializationApi(data)
            .then(response => {            	
            	dispatch({type: actionTypes.SPECIALZATION_ADD_TO_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.SPECIALZATION_ADD_TO_ERROR, payload:error})    
            })
    }
}


export const listSpecializationAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.SPECIALZATION_LIST_REQUEST, payload: data})
        return API.listSpecializationApi(data)
            .then(response => {             
                dispatch({type: actionTypes.SPECIALZATION_LIST_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.SPECIALZATION_LIST_ERROR, payload:error})    
            })
    }
}







// WEBPACK FOOTER //
// ./src/actions/Speclization.js